<template>
  <div
    v-if="schema.value"
    class="error flex flex-align-center">
    <SBIcon
      class="mr-1"
      :icon="SBIconList.ERROR"
      :color="SBColors.redPrimary"
      :size="10" />
    <span>{{ schema.value }}</span>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'CustomValidator',
  components: {
    SBIcon,
  },
  props: {
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      message: null,
      SBColors,
      SBIconList,
    };
  },
  watch: {
    // schema: {
    //   handler() {
    //     console.log('CHANGE');
    //     this.emitData();
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.emitData();
  },
  methods: {
    emitData() {
      // console.log(1);
      this.$emit('input', {
        valid: !this.schema.value,
        name: this.schema.returnKey || '',
        data: this.schema.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  
</style>
